<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroAconex" />   
    <Section :content="register" />
    <Section :content="findInfoFast" />   
    <Section :content="WipToCde" />
    <Section :content="WipAccessControl" />
    <Section :content="accessLatest" />
    <Section :content="connectSilos" />
    <Section :content="mobile" :videoHeightOverride="true" />
    <Section :content="simpleSetup" />
    <Section :content="aconexControl" /> 
    <Section :content="usesOracle" />
    <!--Section :content="trinpodSecure" />
    <Section :content="trueCDE" />
    <Section :content="wipCDE" />
    <Section :content="easySetup" />
    <Section :content="easyLogin" />
    <Section :content="easySetup2" />
    <CallToAction :content="aconexCTA" /-->
    <CallToActionAconexRegister />
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
//import CallToAction from '@/components/call-to-action.vue';
import CallToActionAconexRegister from '../components/call-to-action-aconex-register.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'Aconex',
  components: {
    MainNavBar,
    Hero,
    Section,
    //CallToAction,
    CallToActionAconexRegister,
    GmxFooter
  },
  data() {
    return { 
      heroAconex: { 
        eyebrow: '',
        header: 'Introducing the Aconex Accelerator',
        subheader: 'Aconex Project members can automatically register documents with multiple fields of information to Aconex up to 100+ times faster, and find actionable information in seconds using the Accelerator\'s powerful search, tag and document linking capabilities.',
        img: '',
        videoId: '961761656',
        buttons: [
          { label: 'Auto Register', path: '', id: 'automatic-aconex-register' },
          { label: 'Information Fast', path: '', id: 'find-information-fast' },
          { label: 'WIP \u21c4 CDE', path: '', id: 'wip-to-cde' },
          { label: 'WIP Control', path: '', id: 'wip-access-control' },
          { label: 'Access Latest', path: '', id: 'access-latest-docs' },
          { label: 'Connect Silos', path: '', id: 'connect-silos' },
          { label: 'Mobile', path: '', id: 'fast-when-mobile' },
          { label: 'Simple Setup', path: '', id: 'simple-setup' },
          { label: 'Aconex Control', path: '', id: 'aconex-control' },
          { label: 'Oracle Login', path: '', id: 'oracle-credentials' },
        ]
      },
      register: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Register to Aconex up to 100+ times faster',
        paragraphs: [
          'Save days per project by registration of documents to Aconex using Crosslink automation with human review and approval.'
        ],
        id: 'automatic-aconex-register',
        image: '',
        videoId: '945901280',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        learnMoreLink: '/Aconex/register',
        headlineLink: true,
      },
      simpleSetup: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Simple Setup',
        paragraphs: [
          'Simply go to trinapp.com and click the Smart Construction button to log in with your Oracle credentials.',
          'To create the Oracle TrinPod\u2122 CDE for the first time, the project administrator simply clicks on the Smart Construction button and the CDE is made automatically from the Aconex project information. The CDE is now ready for the whole project team to use.'
        ],
        id: 'simple-setup',
        image: 'browser-smart-construction-button.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      findInfoFast: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Find Information in Minutes, Not Hours',
        paragraphs: [
          'After automatically registering documents with the Accelerator, any Aconex project member can easily find actionable information with the Accelerator\'s powerful search and document-linking capabilities.'
        ],
        id: 'find-information-fast',
        image: '',
        videoId: '961761656',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        learnMoreLink: '/Aconex/find-information-fast',
        headlineLink: true,
      },
      mobile: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Fast when Mobile',
        paragraphs: [
          'Whether at the office or on-site, the Aconex Accelerator can be used on any internet connected device.', 'You can easily work on any size document at any internet speed because the Accelerator splits your documents into individual pages and Units of Thought.'
        ],
        id: 'fast-when-mobile',
        image: '',
        videoId: '897892263',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      aconexControl: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'All Permissions Controlled by Aconex',
        paragraphs: [
          'Users simply log in using their Oracle Smart Construction Platform credentials. Aconex is the single source of truth for all permissions used by the TrinPod\u2122 CDE.'
        ],
        id: 'aconex-control',
        image: 'solid-pod-access-oracle.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      usesOracle: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Login with Oracle Smart Construction Platform',
        paragraphs: [
          'No need to remember another password. Simply login with your Oracle Smart Construction Platform credentials.'
        ],
        id: 'oracle-credentials',
        image: 'login-with-oracle.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      WipToCde: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Oracle Aconex Accelerator CDE',
        paragraphs: [
          'The Accelerator offers a single environment to search and access both the Aconex CDE (Common Data Environment) and your Work In Progress with easy hierarchical control, eliminating rework and the need to copy files from the Aconex CDE.',
        ],
        id: 'wip-to-cde',
        image: 'wips-to-cde.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      accessLatest: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Access to the Latest Documents without Copying',
        paragraphs: [
          'Eliminate massive waste caused by work done from outdated versions due to the need to copy documents from Aconex to your Work In Progress.',
          'With the Accelerator, each project member company has quick access to all of the latest versions of documents in Aconex and to their work in progress from a single application.',
        ],
        id: 'access-latest-docs',
        image: 'silos-no-copy.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      WipAccessControl: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Easy Hierarchical Permission System',
        paragraphs: [
          'Each stakeholder organization has full control over their Work in Progress Project TrinPod\u2122.',
          'Easily add employees and groups to your Organization TrinPod\u2122 or Project TrinPod\u2122 to make collaboration easy and secure with the Accelerator\'s powerful hierarchical permission system.',
        ],
        id: 'wip-access-control',
        image: 'Project-w-collaborators-web.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      connectSilos: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Connect your Silos!',
        paragraphs: [
          'The Accelerator provides one unified environment to access your Aconex Accelerator CDE and your WIP (Work in Progress).',
          'Use one query to search across both your CDE and your WIP with results displayed in a combined list. Open documents stored across your CDE and your WIP in your unified environment.',
        ],
        id: 'connect-silos',
        image: 'single-search.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      aconexCTA: {
        header: 'To get started, all you need is an Oracle Aconex account',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
